module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Patsy Clairmont\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Patsy Clairmont is a popular speaker, a coauthor of various Women of Faith devotionals, and the author of such best-selling books as \"God Uses Cracked Pots\" and \"Sportin' a 'Tude.\" She and her husband live in Brighton, Michigan.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5ZezqJ/tc-custom/9780849922992.jpg?1741121540184",
      "alt": "This image is the cover for the book Twirl"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Twirl\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Is life making you so dizzy that you’re forgetting what’s most important?")])]), _c('p', [_vm._v("Patsy Clairmont loves a good twirl. The kind that will make a child fall to the ground, squeal with laughter, and then want to get up and spin in circles some more! However, there is a twirl where busy schedules and urgency create a different and unwanted variety of dizzy into our lives.")]), _c('p', [_vm._v("Though hurry-up is part of the human dilemma and certain seasons bring more of it than others, if it becomes a lifestyle you might find yourself on the slippery slopes of bitterness, sadness, and depression. Patsy’s hope is to help her readers maintain a dynamic view on life—with activities and choices that lead to renewal and peace. So take a little stroll with Patsy Clairmont through "), _c('i', [_vm._v("Twirl")]), _vm._v(", and allow her unique perspective and deep well of biblical wisdom to realign your spin on life.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0